import { render, staticRenderFns } from "./SystemSettingsTermsAndCondition.vue?vue&type=template&id=28012234"
import script from "./SystemSettingsTermsAndCondition.vue?vue&type=script&lang=js"
export * from "./SystemSettingsTermsAndCondition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports